export default "https://housescan.app.solease.nl/static/media/solar_panels_2.8d7c5ba2.svg";